var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide" } }, [
    _c(
      "div",
      { staticClass: "bg-surface-secondary w-100" },
      [
        _vm.onaddnote
          ? _c("add-note", {
              attrs: { onaddnote: _vm.onaddnote },
              on: {
                onclose: function ($event) {
                  _vm.onaddnote = false
                },
                onreload: function ($event) {
                  return _vm.RELOAD()
                },
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("header", { staticClass: "bg-surface-primary border-bottom" }, [
          _c("div", { staticClass: "container-fluid py-4" }, [
            _c("div", { staticClass: "row align-items-center" }, [
              _c("div", { staticClass: "col" }, [
                _c("div", { staticClass: "d-flex align-items-center gap-4" }, [
                  _c("div", [
                    _c("button", {
                      staticClass: "btn-close text-xs",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.$router.go(-1)
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "vr opacity-20 my-1" }),
                  _vm._v(" "),
                  _c("h1", { staticClass: "h4 ls-tight" }, [
                    _vm._v(
                      "Actualizar paquete - " +
                        _vm._s(_vm.data.type) +
                        _vm._s(_vm.data.id)
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-auto" }, [
                _c("div", { staticClass: "hstack gap-2 justify-content-end" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-h btn-dark px-3",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          _vm.onaddnote = true
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "pe-2" }, [
                        _c("i", { staticClass: "bi bi-card-checklist" }),
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v("Notas")]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-h btn-success px-3",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.UPDATE()
                        },
                      },
                    },
                    [
                      _vm.count == 1
                        ? _c(
                            "div",
                            {
                              staticClass: "spinner-border spinner-border-sm",
                              attrs: { role: "status" },
                            },
                            [
                              _c("span", { staticClass: "sr-only" }, [
                                _vm._v("Loading..."),
                              ]),
                            ]
                          )
                        : _c("span", [_vm._v("Guardar cambios")]),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("main", { staticClass: "py-6 bg-surface-secondary" }, [
          _c(
            "div",
            { staticClass: "container-fluid vstack gap-5" },
            [
              _c(
                "div",
                { staticClass: "border-bottom" },
                [
                  _c(
                    "v-tabs",
                    {
                      on: {
                        change: function ($event) {
                          return _vm.CHANGE()
                        },
                      },
                      model: {
                        value: _vm.tab,
                        callback: function ($$v) {
                          _vm.tab = $$v
                        },
                        expression: "tab",
                      },
                    },
                    [
                      _c("v-tab", { key: "package" }, [_vm._v("Paquete")]),
                      _vm._v(" "),
                      _c("v-tab", { key: "notes" }, [_vm._v("Notas")]),
                      _vm._v(" "),
                      _c("v-tab", { key: "history" }, [_vm._v("Historial")]),
                      _vm._v(" "),
                      _vm.data.invoice
                        ? _c("v-tab", { key: "invoice" }, [
                            _vm._v("Facturación"),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-tabs-items",
                {
                  model: {
                    value: _vm.tab,
                    callback: function ($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab",
                  },
                },
                [
                  _c(
                    "v-tab-item",
                    { key: "package" },
                    [
                      _vm.tab == 0
                        ? _c("package", {
                            attrs: { data: _vm.data, errors: _vm.errors },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-tab-item",
                    { key: "notes" },
                    [
                      _vm.tab == 1
                        ? _c("notes", {
                            attrs: { onreload: _vm.onreload },
                            on: {
                              onreload: function ($event) {
                                _vm.onreload = false
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-tab-item",
                    { key: "history" },
                    [
                      _vm.tab == 2
                        ? _c("history", {
                            attrs: { onhistory: _vm.onhistory },
                            on: {
                              onhistory: function ($event) {
                                _vm.onhistory = false
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.data.invoice
                    ? _c(
                        "v-tab-item",
                        { key: "invoice" },
                        [
                          _vm.tab == 3
                            ? _c("invoice", {
                                attrs: {
                                  state: _vm.data.state_id,
                                  invoice: _vm.data.invoice,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }